import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchEndUser = createAction(constants.FETCH_END_USER)
export const fetchEndUserPending = createAction(constants.FETCH_END_USER_PENDING)
export const fetchEndUserFailed = createAction(constants.FETCH_END_USER_FAILED)
export const fetchEndUserCancelled = createAction(constants.FETCH_END_USER_CANCELLED)
export const receiveEndUser = createAction(constants.RECEIVE_END_USER)

export const updateEndUser = createAction(constants.UPDATE_END_USER)
export const updateEndUserPending = createAction(constants.UPDATE_END_USER_PENDING)
export const updateEndUserFailed = createAction(constants.UPDATE_END_USER_FAILED)

export const fetchEndUserList = createAction(constants.FETCH_END_USER_LIST)
export const fetchEndUserListPending = createAction(constants.FETCH_END_USER_LIST_PENDING)
export const fetchEndUserListFailed = createAction(constants.FETCH_END_USER_LIST_FAILED)
export const fetchEndUserListCancelled = createAction(constants.FETCH_END_USER_LIST_CANCELLED)
export const fetchEndUserListSuccess = createAction(constants.FETCH_END_USER_LIST_SUCCESS)

export const joinEndUserChannel = createAction(constants.JOIN_END_USER_CHANNEL)
export const closeEndUserChannel = createAction(constants.CLOSE_END_USER_CHANNEL)

export const fetchFollowing = createAction(constants.FETCH_FOLLOWING)
export const fetchFollowingPending = createAction(constants.FETCH_FOLLOWING_PENDING)
export const fetchFollowingFailed = createAction(constants.FETCH_FOLLOWING_FAILED)
export const fetchFollowingSuccess = createAction(constants.FETCH_FOLLOWING_SUCCESS)
export const fetchFollowingCancelled = createAction(constants.FETCH_FOLLOWING_CANCELLED)

export const updateFollowing = createAction(constants.UPDATE_FOLLOWING)
export const updateFollowingPending = createAction(constants.UPDATE_FOLLOWING_PENDING)
export const updateFollowingFailed = createAction(constants.UPDATE_FOLLOWING_FAILED)
export const updateFollowingSuccess = createAction(constants.UPDATE_FOLLOWING_SUCCESS)

export const updateCQL = createAction(constants.UPDATE_CQL)
export const updateCQLPending = createAction(constants.UPDATE_CQL_PENDING)
export const updateCQLFailed = createAction(constants.UPDATE_CQL_FAILED)
export const updateCQLSuccess = createAction(constants.UPDATE_CQL_SUCCESS)

export const unsubscribe = createAction(constants.UNSUBSCRIBE)
export const unsubscribeById = createAction(constants.UNSUBSCRIBE_BY_ID)
export const unsubscribeByEncodedEmail = createAction(constants.UNSUBSCRIBE_BY_ENCODED_EMAIL)
export const unsubscribeByEmailAndOrgId = createAction(constants.UNSUBSCRIBE_BY_EMAIL_AND_ORG_ID)
export const unsubscribePending = createAction(constants.UNSUBSCRIBE_PENDING)
export const unsubscribeFailed = createAction(constants.UNSUBSCRIBE_FAILED)
export const unsubscribeSuccess = createAction(constants.UNSUBSCRIBE_SUCCESS)

export const resubscribe = createAction(constants.RESUBSCRIBE)
export const resubscribeByEmailandOrgId = createAction(constants.RESUBSCRIBE_BY_EMAIL_AND_ORG_ID)
export const resubscribePending = createAction(constants.RESUBSCRIBE_PENDING)
export const resubscribeFailed = createAction(constants.RESUBSCRIBE_FAILED)
export const resubscribeSuccess = createAction(constants.RESUBSCRIBE_SUCCESS)

export const checkUnsubscribed = createAction(constants.CHECK_UNSUBSCRIBED)
export const checkUnsubscribedPending = createAction(constants.CHECK_UNSUBSCRIBED_PENDING)
export const checkUnsubscribedFailed = createAction(constants.CHECK_UNSUBSCRIBED_FAILED)
export const checkUnsubscribedSuccess = createAction(constants.CHECK_UNSUBSCRIBED_SUCCESS)

export const fetchUnsubscribedCount = createAction(constants.FETCH_UNSUBSCRIBED_COUNT)
export const fetchUnsubscribedCountPending = createAction(constants.FETCH_UNSUBSCRIBED_COUNT_PENDING)
export const fetchUnsubscribedCountFailed = createAction(constants.FETCH_UNSUBSCRIBED_COUNT_FAILED)
export const fetchUnsubscribedCountSuccess = createAction(constants.FETCH_UNSUBSCRIBED_COUNT_SUCCESS)

export const createPropertyDefinition = createAction(constants.CREATE_PROPERTY_DEFINITION)
export const createPropertyDefinitionPending = createAction(constants.CREATE_PROPERTY_DEFINITION_PENDING)
export const createPropertyDefinitionFailed = createAction(constants.CREATE_PROPERTY_DEFINITION_FAILED)
export const createPropertyDefinitionCancelled = createAction(constants.CREATE_PROPERTY_DEFINITION_CANCELLED)
export const createPropertyDefinitionSuccess = createAction(constants.CREATE_PROPERTY_DEFINITION_SUCCESS)

export const requestContactData = createAction(constants.REQUEST_CONTACT_DATA)
export const requestContactDataPending = createAction(constants.REQUEST_CONTACT_DATA_PENDING)
export const requestContactDataSuccess = createAction(constants.REQUEST_CONTACT_DATA_SUCCESS)
export const requestContactDataFailed = createAction(constants.REQUEST_CONTACT_DATA_FAILED)

export const requestDeleteContactData = createAction(constants.REQUEST_DELETE_CONTACT_DATA)
export const requestDeleteContactDataPending = createAction(constants.REQUEST_DELETE_CONTACT_DATA_PENDING)
export const requestDeleteContactDataSuccess = createAction(constants.REQUEST_DELETE_CONTACT_DATA_SUCCESS)
export const requestDeleteContactDataFailed = createAction(constants.REQUEST_DELETE_CONTACT_DATA_FAILED)

export const requestUnsubDeleteData = createAction(constants.REQUEST_UNSUB_DELETE_DATA)
export const requestUnsubDeleteDataPending = createAction(constants.REQUEST_UNSUB_DELETE_DATA_PENDING)
export const requestUnsubDeleteDataFailed = createAction(constants.REQUEST_UNSUB_DELETE_DATA_FAILED)
export const requestUnsubDeleteDataCancelled = createAction(constants.REQUEST_UNSUB_DELETE_DATA_CANCELLED)
export const requestUnsubDeleteDataSuccess = createAction(constants.REQUEST_UNSUB_DELETE_DATA_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/actions.js